import { useNavigate } from 'react-router-dom'
import { useGetUserProjectParticipations } from '@/lib/actions/getUserProjectParticipations.ts'
import { useUserStore } from '@/store/user.ts'
import { useProjectStageStore } from '@/components/common/menu/lib/store/useProjectStageStore.tsx'
import {
  LocallyStoredFilterT,
  useLocallyStoredFilters,
} from '@/routes/projectStages/issues/lib/stores/useLocallyStoredFilters.ts'
import { useProjectStageFiltersStore } from '@/components/common/menu/lib/store/useProjectStageFilters.ts'
import somethingWrong from '@/lib/helpers/somethingWrong.ts'
import PopoverOverlay from '@/components/common/propertyPopoverOverlay/PopoverOverlay.tsx'
import PropertyPopoverTrigger from '@/components/common/propertyPopoverOverlay/PropertyPopoverTrigger.tsx'
import { Plus } from 'lucide-react'
import { CurrStageData } from '@/lib/actions/getCurrStage.ts'
import getProjectStatusIcon from '@/lib/helpers/getProjectStatusIcon.tsx'
import { NavigationItemT } from '@/lib/types/navigationTypes.ts'

type PropsT = {
  disabled: boolean
}

export function createProjectTab(
  fullPath: string,
  projectStage: CurrStageData | null | undefined,
  userId: number,
  projectStageIssuesLinks: NavigationItemT[],
): LocallyStoredFilterT {
  const iconName = getProjectStatusIcon(projectStage?.status).iconName
  return {
    pathname: fullPath,
    name: projectStage?.name ?? '',
    projectStageId: String(projectStage?.id),
    iconName: iconName,
    id: String(Math.random()),
    userId: userId,
    projectStageIssuesLinks,
  }
}

export default function StageTabTrigger({ disabled }: PropsT) {
  const navigate = useNavigate()
  const { projectParticipationsFlat } = useGetUserProjectParticipations()

  const user = useUserStore(state => state.user)
  const currProjectStage = useProjectStageStore(state => state.currProjectStage)
  const setCurrProjectStage = useProjectStageStore(state => state.setCurrProjectStage)
  const projectStageIssuesLinks = useProjectStageStore(state => state.projectStageIssuesLinks)
  const addTab = useLocallyStoredFilters(state => state.addTab)
  const stagesProperties = useProjectStageFiltersStore(state => state.stagesProperties)

  async function onSelect(val: string) {
    const found = projectParticipationsFlat?.find(
      participation => String(participation?.projectStage?.id) === val,
    )

    const projectStage = found?.projectStage
    if (!projectStage) return somethingWrong()
    // console.log(`onSelect`, val)
    // console.log(`found`, found)

    setCurrProjectStage(projectStage)
    const pathToNavigate = `/project_stages/${val}/dashboard`

    const tabData: LocallyStoredFilterT = createProjectTab(
      pathToNavigate,
      projectStage,
      user?.id as number,
      projectStageIssuesLinks,
    )

    navigate(pathToNavigate)

    addTab(tabData)
  }

  return (
    <div
      className={`ml-auto flex size-8 h-8 shrink-0 items-center justify-center rounded border bg-secondary`}
    >
      <PopoverOverlay
        properties={stagesProperties}
        selectedValues={[String(currProjectStage?.project?.id)]}
        removeSelectedValue={onSelect}
        addSelectedValue={onSelect}
        closeOnSelect
        customTrigger={
          <PropertyPopoverTrigger
            icon={<Plus className={`size-4`} />}
            label={``}
            disabled={disabled}
            variant={`ghost`}
          />
        }
      />
    </div>
  )
}
